export const ACTION_SET_BOOK_NAME = 'SET_BOOK_NAME';

export const setBookName = (name) => {
    return {
        type: ACTION_SET_BOOK_NAME,
        payload: name
    }
}

